module.exports = __webpack_public_path__ + "assets/img/ee6db3f78c52cf5e9937a2c914f75c45.svg";